import {
  CustomGetDailyFormVehicleQuery,
  CustomGetDailyFormVehicleQueryVariables,
  useCustomGetDailyFormVehicleQuery,
} from "generated/graphql";
import { useCallback, useMemo } from "react";

export default function useGetDailyFormVehicle({
  variables,
}: {
  variables: CustomGetDailyFormVehicleQueryVariables;
}) {
  const { data: graphqlData, error, loading, refetch } = useCustomGetDailyFormVehicleQuery({
    variables,
  });

  const getData = useCallback((data?: CustomGetDailyFormVehicleQuery) => {
    return data?.getDailyFormVehicle || null;
  }, []);

  const data = useMemo(() => getData(graphqlData), [graphqlData, getData]);

  return { loading, data, error, getData, refetch } as const;
}
